import { Reducer } from 'redux';

import { loadApp } from '../services/app';
import { ActionTypes } from '../types/action-types';
import { ActionObject, IApp } from '../types/app';

export default ((state = loadApp(), action: ActionObject): IApp => {
  switch (action.type) {
    case ActionTypes.RDIO_UI_UPDATED:
      return {
        ...state,
        configuredExpanded: action.configuredExpanded,
      };
    case ActionTypes.RDIO_SCHEMA_INSTALLED:
      return {
        ...state,
        schemaInstalled: action.schemaInstalled,
      };
  }
  return {...state};
}) as Reducer<IApp>;



// WEBPACK FOOTER //
// ./src/sub-projects/radario/reducers/app.ts